import baseDiscoverService from './base/baseDiscoverService.js';
import baseV3Service from './base/baseV3Service.js';
import baseInsightsService from './base/baseInsightsService.js';

const login = (payload, config) => {
    return baseV3Service.post("auth/login", payload, config);
};
const loginAiDiscover = (payload, config) => {
    return baseDiscoverService.post("auth/login", payload, config);
};
const loginInsights = (payload, config) => {
    return baseInsightsService.post("auth/login", payload, config);
};
const forgotPassword = (payload, config) => {
    return baseV3Service.post("auth/forgot-password", payload, config);
};
const forgotPasswordAiDiscover = (payload, config) => {
    return baseDiscoverService.post("auth/forgot-password", payload, config);
};
const resetPassword = (payload, config) => {
    return baseV3Service.post("auth/reset-password", payload, config);
};
const resetPasswordAiDiscover = (payload, config) => {
    return baseDiscoverService.post("auth/reset-password", payload, config);
};
const getGoogleOAuthURL = (config) => {
    return baseV3Service.get("auth/google-oauth-url", config);
};
const updateGoogleMyBusinessCreds = (payload, config) => {
    return baseV3Service.put("auth/google-credentials", payload, config);
};
const proxyLogin = (userId, config = {}) => {
    return baseV3Service.post(`auth/proxy-login`, { userId }, config);
};
const endProxySession = (config = {}) => {
    return baseV3Service.post(`auth/end-proxy-session`, {}, config);
};
const deleteGmbAccount = (config) => {
    return baseV3Service.delete("auth/google-credentials", config);
};
const acceptTermsConditionsAiDiscover = (userId, config) => {
    return baseDiscoverService.put(`auth/${userId}/terms-and-conditions`, {}, config);
};

export { acceptTermsConditionsAiDiscover, deleteGmbAccount, endProxySession, forgotPassword, forgotPasswordAiDiscover, getGoogleOAuthURL, login, loginAiDiscover, loginInsights, proxyLogin, resetPassword, resetPasswordAiDiscover, updateGoogleMyBusinessCreds };
